import { useEffect } from "react";
import { initLenis } from "@/lib/smoothScroll";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import HirePage from "@/pages/HirePage";
import AdminPage from "@/pages/AdminPage";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import Positioning from "@/components/site/Positioning";
import RotatingBadge from "@/components/site/RotatingBadge";
import Services from "@/components/site/Services";
import Brands from "@/components/site/Brands";
import HeightWork from "@/components/site/HeightWork";
import Inverter from "@/components/site/Inverter";
import Pmoc from "@/components/site/Pmoc";
import WhyUs from "@/components/site/WhyUs";
import Portfolio from "@/components/site/Portfolio";
import BeforeAfter from "@/components/site/BeforeAfter";
import Process from "@/components/site/Process";
import Authority from "@/components/site/Authority";
import Testimonials from "@/components/site/Testimonials";
import Faq from "@/components/site/Faq";
import FinalCta from "@/components/site/FinalCta";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  const path = window.location.pathname;

  if (path.startsWith("/admin")) {
    return (
      <div className="grain bg-ink font-body text-mist antialiased">
        <AdminPage />
        <Toaster position="top-center" />
      </div>
    );
  }

  if (path.startsWith("/contratar")) {
    return (
      <div className="grain bg-ink font-body text-mist antialiased">
        <Header />
        <HirePage />
        <Footer />
        <WhatsAppFab />
        <Toaster position="top-center" />
      </div>
    );
  }

  return (
    <div className="grain bg-ink font-body text-mist antialiased">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <Positioning />
        <RotatingBadge />
        <Services />
        <Brands />
        <HeightWork />
        <Inverter />
        <Pmoc />
        <WhyUs />
        <Portfolio />
        <BeforeAfter />
        <Process />
        <Authority />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
